export default {
  pt: {
    COURSE_PACK_TITLE: `Escolha seus cursos`,
    CLEAN_FILTERS: 'Filtros limpos',
    BANNER_COURSE_PACK_CLEAN: 'Limpar seleção',
    BANNER_COURSE_PACK_RECOMMENDATION: 'Recomende-me cursos',
    COURSE_BANNER_PACK_BUTTON: 'Leve-os',
  },
};
